import { authorizeRequest } from '@u/http/authorizeRequest'
import { apiOrigin, baseURL } from '@u/http/apiOrigin'
import { createHttpClient } from '@u/http/createHttpClient'

export { apiOrigin, baseURL }

const apiClientDocument = createHttpClient({
  baseURL: apiOrigin,
  onRequest: authorizeRequest
})

export default apiClientDocument
